import { createFileRoute } from '@tanstack/react-router';
import { AdminBoardPage } from '@/components/admin/admin-board';

export const Route = createFileRoute('/admin/board')({
  component: AdminBoardPage,
});
